import React from 'react'
import styled from 'styled-components'
import SidebarButton from './SidebarButton'

export type SidebarSectionProps = {
  title?: string
  badge?: string
  description?: string
}

const Badge = styled.div`
  display: inline-block;
  background-color: #cf0000;
  color: #fff;
  border-radius: 2px;
  font-size: 10px;
  line-height: 1;
  padding: 7px 10px;
  vertical-align: 3px;
  margin-left: 7px;
`

const Title = styled.b`
  text-transform: uppercase;
  display: block;
  margin-bottom: 5px;
`

const Description = styled.p`
  font-size: 14px;
  line-height: 1.4;
  margin-bottom: 20px;
`

const SidebarSection = styled.div.attrs<SidebarSectionProps>(({ title, description, badge, children }) => ({
  children: (
    <>
      {!!title && (
        <Title>
          {title}
          {!!badge && <Badge>{badge}</Badge>}
        </Title>
      )}
      {!!description && <Description>{description}</Description>}
      {children}
    </>
  ),
  title: ''
}))<SidebarSectionProps>`
  padding: 20px 25px;

  ${SidebarButton} {
    margin: 0 -25px;
  }

  & + & {
    border-top: 1px solid #eee;
  }
`

export default SidebarSection
